import * as React from 'react'

import { Box, Skeleton } from '@factorialco/deprecated-design-system'

import './index.styles.css'
const Year = () => {
  return (
    <Box paddingY="s32" flexDirection="row" justifyContent="center" alignItems="center">
      <Skeleton width="s80" height="s24" />
    </Box>
  )
}

const DayRows = () => {
  return (
    <Box className={'Calendar_grid'} gap="s8">
      <Skeleton width="full" height="s16" />
      <Skeleton width="full" height="s16" />
      <Skeleton width="full" height="s16" />
      <Skeleton width="s80" height="s16" />
    </Box>
  )
}
const Month = () => {
  return (
    <li className={'Calendar_month'}>
      <Box className={'Calendar_title'}>
        <Skeleton width="s96" height="full" />
      </Box>
      <Box gap="s8">
        <Skeleton width="full" height="s16" />
        <DayRows />
      </Box>
    </li>
  )
}

const Months = () => {
  const numMonths = 12
  const months = Array.from({ length: numMonths }, (_, index) => index + 1)

  return (
    <Box paddingX="s32">
      <ul className={'Calendar_months'}>
        {months.map((_, index) => (
          <Month key={`month_${index}`} />
        ))}
      </ul>
    </Box>
  )
}

const Legend = () => {
  return (
    <Box paddingX="s32" paddingBottom="s24" flexDirection="row" gap="s8">
      <Skeleton width="s80" height="s24" />
      <Skeleton width="s80" height="s24" />
      <Skeleton width="s140" height="s24" />
      <Skeleton width="s120" height="s24" />
    </Box>
  )
}

const SkeletonLoader = () => {
  return (
    <>
      <Year />
      <Months />
      <Legend />
    </>
  )
}

export default SkeletonLoader
